import type * as Schema from 'owa-graph-schema';
import { AppendOnSend, CoercionType } from 'owa-editor-addin-plugin-types/lib/utils/AddinViewState';
import { assertNever } from 'owa-assert';

export function convertAppendOnSendToOws(appendOnSend: Schema.AppendOnSend): AppendOnSend {
    return { ...appendOnSend, typ: mapTyp(appendOnSend.typ) };
}

function mapTyp(typ: Schema.CoercionType): CoercionType {
    switch (typ) {
        case 'Text':
            return CoercionType.Text;
        case 'Html':
            return CoercionType.Html;
        default:
            return assertNever(typ);
    }
}
